require('./src/styles/global.scss');

const objectFitImages = require('object-fit-images');

objectFitImages();
